/* tslint:disable */
/* eslint-disable */
/**
 * BuLLy documentation
 * BuLLy Server
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redcare-pharmacy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, toPathString, createRequestFunction } from '../common.js';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base.js';
/**
 * AccountControllerApi - axios parameter creator
 */
export const AccountControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Used by the customer to retrieve all its orders.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {number} [page]
         * @param {number} [itemsPerPage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV1TenantOrdersGet: (tenant_1, page_1, itemsPerPage_1, ...args_1) => __awaiter(this, [tenant_1, page_1, itemsPerPage_1, ...args_1], void 0, function* (tenant, page, itemsPerPage, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('accountV1TenantOrdersGet', 'tenant', tenant);
            const localVarPath = `/account/v1/{tenant}/orders`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Used by a customer to retrieve a single order.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV1TenantOrdersOrderNumberGet: (tenant_1, orderNumber_1, ...args_1) => __awaiter(this, [tenant_1, orderNumber_1, ...args_1], void 0, function* (tenant, orderNumber, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('accountV1TenantOrdersOrderNumberGet', 'tenant', tenant);
            // verify required parameter 'orderNumber' is not null or undefined
            assertParamExists('accountV1TenantOrdersOrderNumberGet', 'orderNumber', orderNumber);
            const localVarPath = `/account/v1/{tenant}/orders/{orderNumber}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderNumber"}}`, encodeURIComponent(String(orderNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns customer data including EAV customer and RedPointsMembership.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV1TenantUserGet: (tenant_1, ...args_1) => __awaiter(this, [tenant_1, ...args_1], void 0, function* (tenant, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('accountV1TenantUserGet', 'tenant', tenant);
            const localVarPath = `/account/v1/{tenant}/user`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AccountControllerApi - functional programming interface
 */
export const AccountControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = AccountControllerApiAxiosParamCreator(configuration);
    return {
        /**
         * Used by the customer to retrieve all its orders.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {number} [page]
         * @param {number} [itemsPerPage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV1TenantOrdersGet(tenant, page, itemsPerPage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accountV1TenantOrdersGet(tenant, page, itemsPerPage, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountControllerApi.accountV1TenantOrdersGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Used by a customer to retrieve a single order.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} orderNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV1TenantOrdersOrderNumberGet(tenant, orderNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accountV1TenantOrdersOrderNumberGet(tenant, orderNumber, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountControllerApi.accountV1TenantOrdersOrderNumberGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Returns customer data including EAV customer and RedPointsMembership.
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV1TenantUserGet(tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accountV1TenantUserGet(tenant, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountControllerApi.accountV1TenantUserGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * AccountControllerApi - factory interface
 */
export const AccountControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AccountControllerApiFp(configuration);
    return {
        /**
         * Used by the customer to retrieve all its orders.
         * @param {AccountControllerApiAccountV1TenantOrdersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV1TenantOrdersGet(requestParameters, options) {
            return localVarFp.accountV1TenantOrdersGet(requestParameters.tenant, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by a customer to retrieve a single order.
         * @param {AccountControllerApiAccountV1TenantOrdersOrderNumberGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV1TenantOrdersOrderNumberGet(requestParameters, options) {
            return localVarFp.accountV1TenantOrdersOrderNumberGet(requestParameters.tenant, requestParameters.orderNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns customer data including EAV customer and RedPointsMembership.
         * @param {AccountControllerApiAccountV1TenantUserGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV1TenantUserGet(requestParameters, options) {
            return localVarFp.accountV1TenantUserGet(requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccountControllerApi - object-oriented interface
 */
export class AccountControllerApi extends BaseAPI {
    /**
     * Used by the customer to retrieve all its orders.
     * @param {AccountControllerApiAccountV1TenantOrdersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1TenantOrdersGet(requestParameters, options) {
        return AccountControllerApiFp(this.configuration).accountV1TenantOrdersGet(requestParameters.tenant, requestParameters.page, requestParameters.itemsPerPage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Used by a customer to retrieve a single order.
     * @param {AccountControllerApiAccountV1TenantOrdersOrderNumberGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1TenantOrdersOrderNumberGet(requestParameters, options) {
        return AccountControllerApiFp(this.configuration).accountV1TenantOrdersOrderNumberGet(requestParameters.tenant, requestParameters.orderNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns customer data including EAV customer and RedPointsMembership.
     * @param {AccountControllerApiAccountV1TenantUserGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1TenantUserGet(requestParameters, options) {
        return AccountControllerApiFp(this.configuration).accountV1TenantUserGet(requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
}
